import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGoogleCharts from 'vue-google-charts'

import App from './App.vue'

import vuetify from './plugins/vuetify';
import router from "./router";
import VueAxios from 'vue-axios';
import axios from 'axios'

import Vuex from "vuex";
import { store } from "./store/store";
import { imgUrl } from "./services/constants";

Vue.use(Vuex)


Vue.use(VueGoogleCharts)

Vue.use(VueAxios, axios);

// const token = localStorage.getItem('token')
// if (token) {
//   axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
// }
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  config.headers.Authorization = `Bearer ${token}`;

  return config;
});

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

axios.interceptors.request.use(config => {
  store.commit("loading", true)
  return config
})

// URL variables
Vue.prototype.$imgUrl = imgUrl

//
// before a response is returned stop nprogress
axios.interceptors.response.use(response => {
  store.commit("loading", false)
  return response
})

Vue.use(VueRouter)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
